import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getQuestionnaireResponseByLinkId, mdyStringFromISOString } from 'utils';
import { useAppointmentData } from '../../../shared/stores/appointment/appointment.store';
import { InformationCard } from './InformationCard';

export const ResponsibleInformationContainer: FC = () => {
  const { t } = useTranslation();
  const { questionnaireResponse } = useAppointmentData();

  const relationship = getQuestionnaireResponseByLinkId('responsible-party-relationship', questionnaireResponse)
    ?.answer?.[0]?.valueString;

  const firstAndLastName = `
    ${getQuestionnaireResponseByLinkId('responsible-party-first-name', questionnaireResponse)?.answer?.[0]
      ?.valueString}, ${getQuestionnaireResponseByLinkId('responsible-party-last-name', questionnaireResponse)
      ?.answer?.[0]?.valueString}`;

  const dateOfBirth = getQuestionnaireResponseByLinkId('responsible-party-date-of-birth', questionnaireResponse)
    ?.answer?.[0]?.valueDate;

  const birthSex = getQuestionnaireResponseByLinkId('responsible-party-birth-sex', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const phone = getQuestionnaireResponseByLinkId('responsible-party-number', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const email = getQuestionnaireResponseByLinkId('responsible-party-email', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  return (
    <InformationCard
      title={t('responsibleParty.title', 'Responsible party information')}
      fields={[
        {
          label: t('responsibleParty.relationship', 'Relationship'),
          value: relationship,
        },
        {
          label: t('responsibleParty.fullName', 'Full name'),
          value: firstAndLastName,
        },
        {
          label: t('responsibleParty.dateOfBirth', 'Date of birth'),
          value: dateOfBirth && mdyStringFromISOString(dateOfBirth),
        },
        {
          label: t('responsibleParty.birthSex', 'Birth sex'),
          value: birthSex,
        },
        {
          label: t('responsibleParty.phone', 'Phone'),
          value: phone,
        },
        {
          label: t('responsibleParty.email', 'Email'),
          value: email,
        },
      ]}
    />
  );
};
